import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a62d87499f1da00148c7de0_1784900151828_b23d6a46/westtrackgis/src/app/inventory/page.tsx");
